import { AIRCON_HUB_ALTERNATES } from '../../../../../components/market/AirconCityHub'

// Kuala Lumpur aircond service hub. Primary term "aircond"; "aircon" appears
// only as a secondary spelling in body copy (never in title/H1/H2).
const content = {
    title: (c) => `Aircond Service KL from ${c.money(c.tables.general[0].wall)} | Chemical Wash & Gas Top Up`,
    description: (c) =>
        `Aircond service in Kuala Lumpur: general service from ${c.money(c.tables.general[0].wall)}, chemical wash ${c.money(c.tables.chemicalWash[0].wall)}, gas top up and repairs. Fixed prices, condos and landed.`,
    eyebrow: 'Kuala Lumpur',
    h1: 'Aircond Service in Kuala Lumpur',
    lead: (c) =>
        `General service, chemical wash, overhaul, gas top up and repairs for condos, apartments and landed homes across KL and the Klang Valley. Fixed prices before you book - from ${c.money(c.tables.general[0].wall)} for one wall-mounted unit, and less per unit when you service the whole house.`,
    image: 'blog/living/aircon/chinese-aircon-service-man-smiling.jpg',
    imageAlt: 'Aircond technician arriving for a service at a KL home',
    facts: ['Wall-mounted and cassette', 'Fixed prices in RM', 'Condo access arranged'],
    defaultMount: 'Wall',
    priceTitle: 'Aircond service prices in KL',
    priceIntro: 'Choose the service, unit type and how many units. Prices cover units up to 2.0hp; 2.5hp and larger wall units are priced at the ceiling cassette rate.',
    servicesTitle: 'Aircond services we offer in KL',
    servicesIntro: 'Each page explains when you need the service, what is done and what it costs.',
    sections: [
        {
            title: 'Why aircond in KL gets dirty so fast',
            cards: [
                { title: 'Humidity all year', body: 'KL\'s air is humid in every month. The coil and drain tray stay wet, so dust turns into slime and mould grows - the source of that "aircond bau" smell.' },
                { title: 'Afternoon storms', body: 'Heavy thunderstorms bring damp, cool air in fast. Units cycle hard to dry the room, and drains carry more water than usual.' },
                { title: 'Long night hours', body: 'Bedroom units often run 8-10 hours every night. A year of that loads the filter, coil and blower wheel with dust and lint.' },
                { title: 'Condo ledges', body: 'Outdoor units on condo ledges collect leaves and grime and are hard to reach - they get skipped unless the technician is set up for safe ledge access.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'A sensible schedule for KL homes',
            tone: 'muted',
            paragraphs: [
                'Wash filters every two to four weeks. Book a general service every three to four months for units used every night, or every six months for guest rooms. Plan a chemical wash once a year, or sooner if you notice a smell, water drips or weak airflow. Inverter units run quieter and longer, but they need the same cleaning.',
                'If keeping track sounds like a chore, our servicing package bundles three or four services a year at a fixed price.',
            ],
        },
    ],
    areasIntro: 'We cover Kuala Lumpur and the nearby Klang Valley, including Petaling Jaya and Subang Jaya. Each area page notes the homes and aircond issues typical there.',
    faqs: [
        {
            question: 'How much is aircond service in KL?',
            answer: (c) => `A general service costs ${c.money(c.tables.general[0].wall)} for one wall-mounted unit, ${c.money(c.tables.general[1].wall)} for two and ${c.money(c.tables.general[2].wall)} for three. A chemical wash costs ${c.money(c.tables.chemicalWash[0].wall)} per unit, and a chemical overhaul ${c.money(c.tables.chemicalOverhaul[0].wall)}.`,
        },
        {
            question: 'How often should I service my aircond in Malaysia?',
            answer: 'Every three to four months for units used daily, and a chemical wash once a year. Clean the filters yourself every few weeks.',
        },
        {
            question: 'What is the difference between general service and chemical wash?',
            answer: 'A general service cleans the filter, coil surface, blower and drain with water. A chemical wash uses coil cleaner to dissolve built-up dirt and mould - needed when the unit smells, drips or cools weakly even after a general service.',
        },
        {
            question: 'Do you service aircond in condos?',
            answer: 'Yes. Many KL condos require advance notice to management and safe access to the outdoor unit ledge. Tell us your condo name and we prepare the details.',
        },
        {
            question: 'Is "aircond" the same as "aircon"?',
            answer: 'Yes - both mean air conditioner. In Malaysia most people write "aircond"; you will also see "aircon" and "air-cond".',
        },
    ],
    serviceType: 'Air conditioner servicing',
    offers: (c) => [
        { name: 'Aircond general service, 1 unit', price: c.tables.general[0].wall },
        { name: 'Aircond general service, 3 units', price: c.tables.general[2].wall },
        { name: 'Chemical wash, 1 unit', price: c.tables.chemicalWash[0].wall },
        { name: 'Chemical overhaul, 1 unit', price: c.tables.chemicalOverhaul[0].wall },
        { name: 'Gas top up R32, 1 outdoor unit', price: c.tables.gas.R32.half },
        { name: 'Ceiling cassette service, 1 unit', price: c.tables.general[0].ducted },
        { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
    ],
    alternates: AIRCON_HUB_ALTERNATES,
}

export default content
